<div class="page">
  <!-- ENCABEZADO FIJO -->
  <header class="header">
    <button
      mat-icon-button
      class="header-button"
      type="button"
      (click)="cerrar()"
      aria-label="Regresar"
    >
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div class="header-text">
      <h1>Solicitar acceso</h1>
      <p>Completa la información para solicitar una cuenta en Expediente Avicena.</p>
    </div>
  </header>

  <!-- CONTENIDO CON SCROLL -->
  <main class="content">
    <div class="card">
      <form [formGroup]="requestForm" (ngSubmit)="enviarSolicitud()">
        <div class="form-grid">
          <!-- INFORMACIÓN DE LA CLÍNICA -->
          <div class="section-title">
            <mat-icon>local_hospital</mat-icon>
            <h2>Información de la clínica</h2>
          </div>

          <mat-form-field appearance="outline">
            <mat-label>Nombre de la clínica</mat-label>
            <input matInput formControlName="clinicName" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Clave única de establecimientos de salud</mat-label>
            <input matInput formControlName="claveClinica" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Dirección de la clínica</mat-label>
            <input matInput formControlName="direccion" />
          </mat-form-field>

          <!-- INFORMACIÓN DEL GERENTE -->
          <div class="section-title">
            <mat-icon>person</mat-icon>
            <h2>Datos del gerente general</h2>
          </div>

          <mat-form-field appearance="outline">
            <mat-label>Nombre(s) del gerente</mat-label>
            <input matInput formControlName="nombre" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Apellido paterno </mat-label>
            <input matInput formControlName="apellidoPaterno" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Apellido materno</mat-label>
            <input matInput formControlName="apellidoMaterno" />
          </mat-form-field>

          <!-- CÉDULA -->
          <mat-form-field appearance="outline">
            <mat-label>Tipo de cédula</mat-label>

            <mat-select formControlName="tipoCedula">
              @for (tipo of tiposCedula; track tipo.valor) {
                <mat-option [value]="tipo.valor">
                  {{ tipo.nombre }}
                </mat-option>
              }
            </mat-select>

            @if (requestForm.get('tipoCedula')?.hasError('required')) {
              <mat-error> El tipo de cédula es obligatorio. </mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Cédula profesional</mat-label>
            <input matInput formControlName="cedula" />
          </mat-form-field>

          <!-- ACCESO A LA PLATAFORMA -->
          <div class="section-title">
            <mat-icon>lock</mat-icon>
            <h2>Datos de acceso</h2>
          </div>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Correo electrónico</mat-label>
            <input matInput type="email" formControlName="email" autocomplete="email" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Contraseña</mat-label>

            <input
              matInput
              [type]="mostrarPassword ? 'text' : 'password'"
              formControlName="password"
              autocomplete="new-password"
            />

            <button
              mat-icon-button
              matSuffix
              type="button"
              (click)="mostrarPassword = !mostrarPassword"
              [attr.aria-label]="mostrarPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
              [attr.aria-pressed]="mostrarPassword"
            >
              <mat-icon>
                {{ mostrarPassword ? 'visibility_off' : 'visibility' }}
              </mat-icon>
            </button>
          </mat-form-field>
        </div>

        <!-- BOTONES -->
        <div class="actions">
          <button mat-stroked-button type="button" class="boton-cancelar" (click)="cerrar()">
            Cancelar
          </button>

          <button
            mat-flat-button
            type="submit"
            class="boton-enviar"
            [disabled]="requestForm.invalid"
          >
            <mat-icon>send</mat-icon>
            Enviar solicitud
          </button>
        </div>
      </form>
    </div>
  </main>
</div>
